import React, { useEffect, useRef } from 'react';
import { ScreenBg } from './styled';

const Screen = () => {
    // const [on, setOn] = useState(true);
    const scaleBlock = useRef<HTMLDivElement | null>(null);
    const screenBlock = useRef<HTMLDivElement | null>(null);

    //     const screenText = `+------------------------------------------------------+
    // |                                                      |
    // |   root@sasctf:~$ cat flag.txt                        |
    // |   SAS{w3lc0m3_t0_S4S_2026}                           |
    // |                                                      |
    // |                   ++++++++++++++++                   |
    // |               +++++++++++++     ++++++               |
    // |             +++++++++++  ++   +++   ++++             |
    // |           +++++++++++++++++++++++     ++++           |
    // |         ++++     ++++++++++    ++++     ++++         |
    // |        +++     ++++ +++  ++  ++++++++     +++        |
    // |       +++     ++ +++  ++++++++      ++     +++       |
    // |       ++     +++++++++   ++++++++    +++    ++       |
    // |      ++     ++   ++++  ++++++++ ++  + +++    ++      |
    // |      ++    ++    +++++ ++++++++++ + +++++++++++      |
    // |      ++    ++   +   ++++    +++++  +   ++++++++      |
    // |      +++++++++++++++  ++++++ ++++++++++++++++++      |
    // |      ++    ++   +     ++    +++ ++ +   +++  +++      |
    // |      ++    ++    +      ++++      ++++++++  +++      |
    // |      ++    +++    +             +++++++++++ +++      |
    // |       ++    +++    ++    ++    +++++++++++++++       |
    // |       +++     ++     +++++++++++++++++++++++++       |
    // |        +++     +++       ++++++++++++++++++++        |
    // |         ++++     ++++    +++++++++++++++++++         |
    // |           ++++       +++++++++++++++++++++           |
    // |             ++++         ++ ++++++++++++             |
    // |               ++++++     ++ +++ ++++++               |
    // |                   ++++++++++++++++                   |
    // |                                                      |
    // +------------------------------------------------------+
    //     `;

    useEffect(() => {
        const resize = () => {
            if (scaleBlock && screenBlock && scaleBlock.current) {
                const width = screenBlock.current?.offsetWidth ?? 700;
                scaleBlock.current.style.transform = `scale(${width / 1351.4})`;
            }
        };

        resize();

        window.addEventListener('resize', resize);

        return () => {
            window.removeEventListener('resize', resize);
        };
    }, []);

    return (
        <ScreenBg ref={screenBlock}>
            <img src="/assets/computer/sas-code.png" />
            {/* <ScreenContent ref={scaleBlock}>
                <ScreenBlock>
                    <ScreenTextBlock>{on && <pre>{screenText}</pre>}</ScreenTextBlock>
                    <SwitcherBlock>
                        <Switcher onClick={() => setOn(!on)} />
                    </SwitcherBlock>
                </ScreenBlock>
            </ScreenContent> */}
        </ScreenBg>
    );
};

export default Screen;
